module.exports = __webpack_public_path__ + "img/客户预开户操作手册3940.96b40b23.png";